export var TestEnvironmentKind;
(function (TestEnvironmentKind) {
    TestEnvironmentKind["None"] = "None";
    TestEnvironmentKind["UnitTesting"] = "Unit Testing";
})(TestEnvironmentKind || (TestEnvironmentKind = {}));
//# sourceMappingURL=TestEnvironmentKind.js.map